/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { UploadTask } from "./UploadTask";
import {
  UploadTaskFromJSON,
  UploadTaskFromJSONTyped,
  UploadTaskToJSON,
  UploadTaskToJSONTyped,
} from "./UploadTask";

/**
 *
 * @export
 * @interface ApiUploadtasksList200Response
 */
export interface ApiUploadtasksList200Response {
  /**
   *
   * @type {number}
   * @memberof ApiUploadtasksList200Response
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof ApiUploadtasksList200Response
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiUploadtasksList200Response
   */
  previous?: string | null;
  /**
   *
   * @type {Array<UploadTask>}
   * @memberof ApiUploadtasksList200Response
   */
  results: Array<UploadTask>;
}

/**
 * Check if a given object implements the ApiUploadtasksList200Response interface.
 */
export function instanceOfApiUploadtasksList200Response(
  value: object
): value is ApiUploadtasksList200Response {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function ApiUploadtasksList200ResponseFromJSON(json: any): ApiUploadtasksList200Response {
  return ApiUploadtasksList200ResponseFromJSONTyped(json, false);
}

export function ApiUploadtasksList200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApiUploadtasksList200Response {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(UploadTaskFromJSON),
  };
}

export function ApiUploadtasksList200ResponseToJSON(json: any): ApiUploadtasksList200Response {
  return ApiUploadtasksList200ResponseToJSONTyped(json, false);
}

export function ApiUploadtasksList200ResponseToJSONTyped(
  value?: ApiUploadtasksList200Response | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(UploadTaskToJSON),
  };
}
